// extracted by mini-css-extract-plugin
module.exports = {"sider":"Sider_sider__1kHOw","isExpanded":"Sider_isExpanded__3omga","skeleton":"Sider_skeleton__2FZhs","content":"Sider_content__2toHh"};